export const ERROR_MESSAGES = {
  ZeroAmount: 'Amount must be greater than zero.',
  ZeroAddress: 'Service temporarily unavailable due to configuration error.',
  InsufficientBalance: 'You don’t have enough MZUSD for this action.',
  InsufficientLiquidity: 'Insufficient liquidity.',
  InsufficientLiquidityOnVault: 'Not enough USDC liquidity in the vault. Please try again later.',
  GlobalHourlyCapExceeded: 'Redemption limit for this period has been reached.',
  ZeroCap: 'Redemption cap must be greater than zero.',
  ZeroDuration: 'Redemption window duration must be greater than zero.',
  DepositLimitExceeded: 'The entered amount exceeds the current deposit limit. Please try a smaller amount.',
  ZeroAssetSupply: 'Operation is temporarily unavailable due to zero total supply.',
  ZeroPassedShares: 'Amount must be greater than zero.',
  InvalidAmount: 'Invalid amount. Please enter a value greater than zero.',
  InvalidBalance: 'You don’t have enough shares to complete this request.',
  NoPendingUnstake: 'There is no pending unstake request to cancel.',
  TooLateToCancel: 'Cancellation period has ended for this epoch.',
  AlreadyFinalized: 'This epoch is already finalized. Please claim your assets instead.',
  NotFinalized: 'This epoch is not finalized yet. Claiming is not available.',
  NothingToClaim: 'There are no assets to claim for this epoch.',
  DirectWithdrawModeEnabled: 'This action is not available while direct withdrawal mode is enabled.',
  DirectWithdrawModeDisabled: 'This action is only available in direct withdrawal mode.',
  CategoryPaused: 'This action is temporarily paused. Please try again later.',
} as const;

export const DEFAULT_TRANSACTION_ERROR_MESS = 'Transaction failed';

export const GAS_LIMIT_TOO_HIGH_MESS =
  'Transaction gas limit is too high. Try again or switch RPC in your wallet.';

export const WYLDS_ALLOWANCE_INSUFFICIENT_MESS =
  'The wYLDS allowance is lower than the amount to mint. Approve again.';

export const USER_REJECTED_TRANSACTION_MESS = 'Transaction declined in wallet.';
